import { Accordion, AccordionProps, Stack, Text } from 'ui';

export const LearnMoreGenericAccordion = (props: AccordionProps) => {
  return (
    <Accordion {...props}>
      <Accordion.Item value="item_1">
        <Accordion.Control>What is Givebacks?</Accordion.Control>
        <Accordion.Panel>
          Givebacks is an inclusive giving platform that allows you to support a cause you care
          about in a way that makes sense for you! By enrolling in the Givebacks Dining & In-Store
          Program or the Givebacks Online Shopping Program, you will earn free merchant-funded
          donations for a cause you care about when you shop as you normally would. It doesn’t cost
          you a thing! Or, you can use Givebacks to make a direct one-time or recurring donation to
          support your cause. Givebacks is a MemberHub company.
        </Accordion.Panel>
      </Accordion.Item>

      <Accordion.Item value="item_2">
        <Accordion.Control>How do I earn cashback donations on Givebacks?</Accordion.Control>
        <Accordion.Panel>
          <Stack gap="xs">
            <Text lh="15px">
              Givebacks provides two unique ways for you to support your favorite cause for free.
            </Text>
            <Stack gap={4}>
              <Text fw={700} lh="15px">
                {' '}
                1. In-store & Dining Program
              </Text>
              <Text lh="15px">
                Swipe & Earn at 16,000+ local restaurants. Just link your card during setup or visit
                your Givebacks wallet any time to link any (or all!) of your credit cards. Purchases
                on your eligible card will automatically create cashback donations.
              </Text>
            </Stack>
            <Stack gap={4}>
              <Text fw={700} lh="15px">
                2. Online Shopping Program
              </Text>
              <Text lh="15px">
                Activate & Earn at 25,000+ online retailers. Just get the extension! You can install
                the extension via a Chrome Browser extension on your computer or follow the steps in
                the Givebacks App to add the extension on your phone. Whenever you visit an eligible
                retailer, click Activate to earn cashback donations on eligible purchases.
              </Text>
            </Stack>
          </Stack>
        </Accordion.Panel>
      </Accordion.Item>
      <Accordion.Item value="item_3">
        <Accordion.Control>Why should I join?</Accordion.Control>
        <Accordion.Panel>
          You get to do good without doing extra! Enroll today to earn free donations funded by
          shops & restaurants you love.
        </Accordion.Panel>
      </Accordion.Item>
      <Accordion.Item value="item_4">
        <Accordion.Control>Is it free?</Accordion.Control>
        <Accordion.Panel>
          Yes! It's free for you! Givebacks collects a fee from participating merchants to fund your
          automatic cashback and donations.
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
};
